import { Routes } from '@angular/router';
import { AppLayout } from './app/layout/component/app.layout';
import { AuthComponent } from '@app/features/auth/auth.component';
import { DashboardComponent } from '@app/features/dashboard/dashboard.component';
import { AppSubLayout } from '@app/layout/component/app.sub-layout';
import { ProductList } from '@app/features/product/product-list/product-list';
import { ProductDetail } from '@app/features/product/product-detail/product-detail';
import { productResolver } from '@app/core/resolvers';
import { isSignedInGuard } from '@app/core/guards';
import { ProductForm } from '@app/features/product/product-form/product-form';
import { MarqueList } from '@app/features/marque/marque-list/marque-list';
import {EbayListPrix} from "@app/features/ebay/ebay-list-prix/ebay-list-prix";
import {EbpError} from "@app/features/ebp/ebp-error/ebp-error";
import {EbayShops} from "@app/features/ebay/ebay-shops/ebay-shops";
import {EbaySearch} from "@app/features/ebay/ebay-search/ebay-search";
import {EbayModifiedProduct} from "@app/features/ebay/ebay-modified-product/ebay-modified-product";

export const appRoutes: Routes = [
    {
        path: '',
        redirectTo: '/dashboard',
        pathMatch: 'full',
    },
    {
        path: '',
        component: AppLayout,
        canActivate: [isSignedInGuard],
        children: [
            {
                path: 'dashboard',
                title: 'Tableau de bord',
                component: DashboardComponent
            },
            {
                path: 'products',
                title: 'Produits',
                component: AppSubLayout,
                children: [
                    {
                        path: '',
                        title: 'Liste des produits',
                        component: ProductList
                    },
                    {
                        path: 'ajouter',
                        title: 'Ajouter un produit',
                        component: ProductForm,
                    },
                    {
                        path: ':id',
                        title: 'Détail d\'un produit',
                        component: ProductDetail,
                        resolve: {
                            product: productResolver
                        }
                    }
                ]
            },
            {
                path: 'marques',
                title: 'Marques',
                component: AppSubLayout,
                children: [
                    {
                        path: '',
                        title: 'Liste des marques',
                        component: MarqueList
                    }
                ]
            },
            {
                path: 'ebay',
                title: 'Ebay',
                component: AppSubLayout,
                children: [
                    {
                        path: '',
                        title: 'Écarts de prix',
                        component: EbayListPrix
                    },
                    {
                        path: 'shops',
                        title: 'Boutiques Ebay',
                        component: EbayShops
                    },
                    {
                        path: 'search',
                        title: 'Recherches personnalisées ebay',
                        component: EbaySearch
                    },
                    {
                        path: 'modified',
                        title: 'Produits modifiés post-Ebay',
                        component: EbayModifiedProduct
                    }
                ]
            },
            {
                path: 'ebp',
                title: 'EBP',
                component: AppSubLayout,
                children: [
                    {
                        path: '',
                        title: 'Erreurs EBP',
                        component: EbpError
                    }
                ]
            }
        ]
    },
    {
        path: 'auth',
        component: AuthComponent
    },
];
